'use es6';
/**
 * @class
 */

export default class ContentAvailability {
  /**
   * @constructor
   */
  constructor(widget, options = {
    isGlobalGroup: false,
    isCustomWidget: false
  }) {
    this.widget = widget;
    Object.assign(this, options);
  }

  get isUnavailableForNewContent() {
    return (this.isGlobalGroup || this.isCustomWidget && this.widget.schemaVersion > 1) && !this.widget.isAvailableForNewContent;
  }

}